import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Company from '../views/Company.vue'
import Product from '../views/Product.vue'
import ProductInfo from '../views/ProductInfo.vue'
import Affiliate from '../views/Affiliate.vue'
import AffiliateInfo from '../views/AffiliateInfo.vue'
import AffiliateGallery from '../views/AffiliateGallery.vue'
import AffiliateRecipes from '../views/AffiliateRecipes.vue'
import Kitchen from '../views/Kitchen.vue'
import News from '../views/News.vue'
import Contact from '../views/Contact.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/company',
    name: 'Our Company',
    component: Company
  },
  {
    path: '/products',
    name: 'Our Products',
    component: Product
  },
  {
    path: '/products/:pid',
    name: 'Product Info',
    component: ProductInfo
  },
  {
    path: '/affiliate',
    name: 'Affiliates',
    component: Affiliate
  },
  {
    path: '/affiliate/:affiliate_id',
    name: 'Affiliate Info',
    component: AffiliateInfo
  },
  {
    path: '/affiliate/:affiliate_id/gallery',
    name: 'Affiliate Gallery',
    component: AffiliateGallery
  },
  {
    path: '/affiliate/:affiliate_id/recipes',
    name: 'Affiliate Recipes',
    component: AffiliateRecipes
  },
  {
    path: '/kitchen/:kitchen_id',
    name: 'Kitchen Recipe',
    component: Kitchen
  },
  {
    path: '/news/:affiliate_id',
    name: 'News',
    component: News
  },
  {
    path: '/contact-us',
    name: 'Contact Us',
    component: Contact
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
]

// const router = new VueRouter({
//   routes
// })
const router = new VueRouter({
  mode: 'history',
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition;
  //   }
  //   if (to.hash) {
  //     return { selector: to.hash };
  //   }
  //   return { x: 0, y: 0 }
  // },
});
export default router
